<div>
  @if (title) {
    <div class="my-2">
      <div class="row">
        <div class="col">
          <ion-label class="color-medium text-uppercase">{{ title }}</ion-label>
        </div>

        @if (this.information) {
          <div class="col-auto">
            <div class="pointer-hover" (click)="callInformation()">
              <i class="fa-regular fa-info-circle color-primary"></i>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (this.warningMode === LabelConfigurationWarningMode.NONE) {
    <div
      (click)="openModal()"
      style="margin-left: -1.5rem !important; margin-right: -1.5rem !important"
      class="px-4 py-1 bg-white"
    >
      <ion-list lines="none">
        <ion-item class="pointer-hover">
          <ion-label>{{ name }}</ion-label>

          <div slot="end" class="color-primary">
            {{ value }}
            <i class="fa-regular fa-chevron-right"></i>
          </div>
        </ion-item>
      </ion-list>
    </div>
  } @else if (this.warningMode === LabelConfigurationWarningMode.NEED_UPDATE) {
    <div
      style="
        margin-left: -1.5rem !important;
        margin-right: -1.5rem !important;
        opacity: 0.5;
        pointer-events: none !important;
      "
      class="px-4 py-1 bg-white"
    >
      <ion-list lines="none">
        <ion-item class="pointer-hover">
          <ion-label>
            {{ name }}
            <div>
              <div
                class="d-inline-block fs-12 bg-orange"
                style="color: white; border-radius: 15px; padding: 2px 10px"
              >
                {{ 'labelconfiguration.needupdate' | translate }}
              </div>
            </div>
          </ion-label>

          <div slot="end" class="color-primary">
            {{ value }}
            <i class="fa-regular fa-chevron-right"></i>
          </div>
        </ion-item>
      </ion-list>
    </div>
  } @else if (this.warningMode === LabelConfigurationWarningMode.NEW) {
    <div
      (click)="openModal()"
      style="margin-left: -1.5rem !important; margin-right: -1.5rem !important"
      class="px-4 py-1 bg-white"
    >
      <ion-list lines="none">
        <ion-item class="pointer-hover">
          <ion-label
            >{{ name }}
            <div>
              <div
                class="d-inline-block fs-12 warningColor"
                style="color: white; border-radius: 15px; padding: 2px 10px"
              >
                {{ 'labelconfiguration.new' | translate }}
              </div>
            </div>
          </ion-label>

          <div slot="end" class="color-primary">
            {{ value }}
            <i class="fa-regular fa-chevron-right"></i>
          </div>
        </ion-item>
      </ion-list>
    </div>
  }

  @if (this.description) {
    <p class="my-3 mb-4 color-medium">
      {{ description }}
    </p>
  }

  <!-- Modal inline -->
  <ion-modal [isOpen]="isModalOpen" (didDismiss)="closeModal()">
    <ng-template>
      <div class="bg-background-secondary">
        <app-global-page-header [title]="name | translate">
          <div slot="end">
            <ion-button
              color="medium"
              fill="clear"
              shape="round"
              (click)="closeModal()"
            >
              <i class="fa-solid fa-times"></i>
            </ion-button>
          </div>
        </app-global-page-header>
      </div>
      <ion-content>
        <div>
          <ion-list lines="none">
            @for (item of this.list; track item.ref) {
              <ion-item
                class="pointer-hover py-1 px-4"
                (click)="selectItem(item.ref)"
              >
                <ion-label>
                  <span [class.color-primary]="selectedValue === item.ref">
                    {{ item.label | translate }}
                  </span>
                </ion-label>

                @if (selectedValue === item.ref) {
                  <div slot="end" class="color-primary">
                    <i class="fa-regular fa-check"></i>
                  </div>
                }
              </ion-item>
            }
          </ion-list>
        </div>
      </ion-content>

      <ion-footer>
        <div class="bg-background-secondary" style="height: 2px"></div>
        <div class="p-3">
          <div class="row">
            <div class="col-6 text-start">
              <ion-button
                expand="block"
                fill="outline"
                color="medium"
                (click)="closeModal()"
              >
                {{ 'generic.cancel' | translate }}
              </ion-button>
            </div>
            <div class="col-6 text-end">
              <ion-button
                expand="block"
                color="primary"
                (click)="confirmSelection()"
              >
                {{ 'generic.confirm' | translate }}
              </ion-button>
            </div>
          </div>
        </div>
      </ion-footer>
    </ng-template>
  </ion-modal>
</div>
